import { icons, aliases } from '@clickadilla/components/icons'
import { h } from 'vue'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {},
      dark: {}
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      custom: {
        component: (props) => h(props.tag, [h(icons[props.icon], { class: 'global-icon-svg' })])
      }
    }
  }
})
